var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"circle-number",class:_vm.variant},[_c('span',{class:[
            _vm.numberInput && _vm.numberInput.length > 2
                ? 'circle-number-3'
                : 'circle-number-2' ]},[_vm._v(_vm._s(_vm.numberInput))])])}
var staticRenderFns = []

export { render, staticRenderFns }